export class FindAccountAssociation {
	acctNumber: number;
	enabled: boolean;
	page: number;
	pageSize: number;

	constructor(){
		this.acctNumber = 0;
		this.enabled = false;
		this.page = 0;
		this.pageSize = 0;
	}
}
